import { action } from 'typesafe-actions';

import { IKnmRegistryItem } from 'APIPackage/KnmModule/interfaces/IKnmRegistryItem';
import { KnmRegistryTypeEnum } from 'APIPackage/KnmModule/enums/KnmRegistryTypeEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';

import { KnmRegistryActionsEnum } from '../enums/KnmRegistryActionsEnum';

export const knmRegistrySetData = (data: IKnmRegistryItem[]) =>
  action(KnmRegistryActionsEnum.KNM_REGISTRY_SET_DATA, { data });
export const knmRegistryGetData = (id: string, type: string) =>
  action(KnmRegistryActionsEnum.KNM_REGISTRY_GET_DATA, { id, type });
export const knmRegistryExport = (
  id: string,
  registryType: keyof typeof KnmRegistryTypeEnum,
  format: ExportFormatsEnum,
) => action(KnmRegistryActionsEnum.KNM_REGISTRY_EXPORT, { id, registryType, format });
